import { Button, FormControl, Grid, Menu, MenuItem, Paper, Tab, Tabs, Typography, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState, useEffect, useContext } from "react";
import YourMentors from "../../Mentorship/Yourmentors";
import MentorshipContainer from "../../Mentorship/Mentorship";
import { featuredCardData } from "../../Network/NetworkData";
import { useStyles } from './style';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import PhotoContainer from "./PhotoContainer";
import AlbumContainer from "./AlbumContainer";
import { getPhotosAndAlbums } from "../../../Utils/apiService";
import { AuthContext } from "../../../Helpers/Contexts/authContext";
import { AuthUser } from "../../../interfaces/Contexts";
import { useNavigate } from "react-router-dom";
import routes from "../../../Utils/routes";
import CreateAlbumModal from "./Components/createAlbum";
import FilterIcon from '../../../Assets/filter.svg';

const sampleData = [
  {
    id: 1,
    userName: 'Ranav J',
    avatarUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
    imageUrl: 'https://3.img-dpreview.com/files/p/TS600x600~sample_galleries/9737283555/4421694065.jpg',
    likes: 124,
    comments: 96,
  },
  {
    id: 2,
    userName: 'Akash Sharma',
    avatarUrl: 'https://randomuser.me/api/portraits/men/41.jpg',
    imageUrl: 'https://images.unsplash.com/photo-1595152772835-219674b2a8a6',
    likes: 96,
    comments: 20,
  },
  {
    id: 3,
    userName: 'Sanjay Kumar',
    avatarUrl: 'https://randomuser.me/api/portraits/men/50.jpg',
    imageUrl: 'https://images.unsplash.com/photo-1588702547923-7093a6c3ba33',
    likes: 56,
    comments: 29,
  },
  {
    id: 4,
    userName: 'Praveen Kumar',
    avatarUrl: 'https://randomuser.me/api/portraits/men/60.jpg',
    imageUrl: 'https://petapixel.com/assets/uploads/2023/05/Z_DX24_F1.7_02_FK_5975_A4-800x534.jpg',
    likes: 89,
    comments: 45,
  },
];

const sampleData2 = [
  {
    id: 1,
    userName: 'Ranav J',
    avatarUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
    imageUrl: 'https://3.img-dpreview.com/files/p/TS600x600~sample_galleries/9737283555/4421694065.jpg',
    collaborators: 16,
    title: "Back to where It began",
    Lastupdated: "30 May, 2025"
  },
  {
    id: 2,
    userName: 'Akash Sharma',
    avatarUrl: 'https://randomuser.me/api/portraits/men/41.jpg',
    imageUrl: 'https://images.unsplash.com/photo-1595152772835-219674b2a8a6',
    collaborators: 6,
    title: "Footprints of friendship",
    Lastupdated: "1 May, 2025"
  },
  {
    id: 3,
    userName: 'Sanjay Kumar',
    avatarUrl: 'https://randomuser.me/api/portraits/men/50.jpg',
    imageUrl: 'https://images.unsplash.com/photo-1588702547923-7093a6c3ba33',
    collaborators: 9,
    title: "Alumni gala 2025",
    Lastupdated: "30 jun, 2025"
  },
  {
    id: 4,
    userName: 'Praveen Kumar',
    avatarUrl: 'https://randomuser.me/api/portraits/men/60.jpg',
    imageUrl: 'https://petapixel.com/assets/uploads/2023/05/Z_DX24_F1.7_02_FK_5975_A4-800x534.jpg',
    collaborators: 10,
    title: "Squad goals in action",
    Lastupdated: "3 May, 2025"
  },
];

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const Photos = () => {
  const [value, setValue] = React.useState(() => {
    const savedTab = localStorage.getItem('photoAlbumActiveTab');
    return savedTab ? parseInt(savedTab, 10) : 0;
  });
  const [photoSortby, setPhotoSortby] = useState('');
  const [albumSortby, setAlbumSortby] = useState('');
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [photosData, setPhotosData] = useState<any[]>([]);
  const [albumsData, setAlbumsData] = useState<any[]>([]);
  console.log(albumsData, "albumsData")
  const [loading, setLoading] = useState(false);
  const { state: { user } } = useContext(AuthContext);
  const [createAlbumModalOpen, setCreateAlbumModalOpen] = useState(false);
  const userData = user as AuthUser;
  const navigate = useNavigate();

  useEffect(() => {
    fetchPhotosAndAlbums();
  }, []);

  const fetchPhotosAndAlbums = async () => {
    setLoading(true);
    try {
      const response = await getPhotosAndAlbums();
      console.log("Photos and Albums API response:", response);

      if (response && response.data && response.data.data) {
        const photos = response.data.data.photos || [];
        const albums = response.data.data.albums || [];

        setPhotosData(photos);
        setAlbumsData(albums);

        localStorage.setItem('albumsData', JSON.stringify(albums));
      }
    } catch (error) {
      console.error("Error fetching photos and albums:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddAlbumClick = () => {
    setCreateAlbumModalOpen(true);
  };

  const handleAlbumCreationSuccess = () => {
    fetchPhotosAndAlbums(); // Refresh the data
  };


  const handleAddPhotosClick = () => {
    const albumsInfo = albumsData.map(album => ({
      id: album.Id,
      name: album.Name,
    }));
    const photosInfo = photosData.map(photo => ({
      id: photo.Id,
      name: photo.Name,
      fileLink: photo.File_Link__c,
      description: photo.Description__c,
      location: photo.Location__c,
      createdDate: photo.CreatedDate
    }));

    console.log("Albums Info:", albumsInfo);
    console.log("Photos Info:", photosInfo);

    navigate(routes.PhotoAlbumUpload, {
      state: {
        albums: albumsInfo,
        photos: photosInfo
      }
    });
  };
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    localStorage.setItem('photoAlbumActiveTab', newValue.toString());
  };
  const sortLabel = value === 0 ? photoSortby : albumSortby;
  const filterAndSortDataPhotos = (data: any[]) => {
    const sorted = [...data];
    if (photoSortby === "Newest First") {
      return sorted.sort((a, b) => new Date(b.CreatedDate).getTime() - new Date(a.CreatedDate).getTime());
    } else if (photoSortby === "Oldest First") {
      return sorted.sort((a, b) => new Date(a.CreatedDate).getTime() - new Date(b.CreatedDate).getTime());
    }
    return sorted;
  };

  const filterAndSortDataAlbums = (data: any[]) => {
    const sorted = [...data];
    if (albumSortby === "Newest First") {
      return sorted.sort((a, b) => new Date(b.CreatedDate).getTime() - new Date(a.CreatedDate).getTime());
    } else if (albumSortby === "Oldest First") {
      return sorted.sort((a, b) => new Date(a.CreatedDate).getTime() - new Date(b.CreatedDate).getTime());
    }
    return sorted;
  };

  const displayedPhotos = filterAndSortDataPhotos(photosData);
  const displayedAlbums = filterAndSortDataAlbums(albumsData);


  //
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const isSortMenuOpen = Boolean(anchorEl);
  const sortOptions = ['Newest First', 'Oldest First'];
  const handleSortSelect = (option: string) => {
    if (value === 0) {
      setPhotoSortby(option);
    } else {
      setAlbumSortby(option);
    }
    setAnchorEl(null);
  };

  const handleSortButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleSortMenuClose = () => {
    setAnchorEl(null);
  };


  return (
    <Box
      sx={{
        height: "calc(100vh - 143px)",
        textAlign: "left",
        overflow: "hidden",
      }}
      className="scrollbar-cusgrayHeader"
    >
      <Grid container style={{ textAlign: "left", position: "sticky", top: 0, zIndex: 10 }}>
        <Grid
          item
          md={12}
          lg={12}
          xl={12}
          xs={12}
          style={{ backgroundColor: "white",  padding: "15px 15px 0px 15px", borderRadius: "8px" }}
          sx={{
            marginTop: { xs: '6px', sm: '6px' , md:"15px" },
            padding: { xs: '8px 12px 0px 12px', sm: '15px 15px 0px 15px' },
          }}
        >
          <Box>
            <Tabs TabIndicatorProps={{
              style: {
                backgroundColor: '#FAB400'
              },
            }}
              value={value}
              onChange={handleChange}
              variant={isMobile ? 'fullWidth' : 'standard'}
              aria-label="basic tabs example"
            >
              <Tab
                label="Photos"
                {...a11yProps(0)}
                sx={{
                  textTransform: 'none',
                  fontSize: 16,
                  '&.Mui-selected': {
                    color: '#373A45', // or use theme color like '#FFC107'
                  }
                }}
              />
              <Tab
                label="Albums"
                {...a11yProps(1)}
                sx={{
                  textTransform: 'none',
                  fontSize: 16,
                  '&.Mui-selected': {
                    color: '#373A45',
                  }
                }}
              />
            </Tabs>
          </Box>
        </Grid>
      </Grid>
      <CustomTabPanel value={value} index={0}>
        <Grid container style={{ height: "calc(100vh - 235px)", overflow: "hidden" }}>
          <Grid
            item
            lg={12}
            xl={12}
            style={{ backgroundColor: "white", width:"100%",borderRadius: "8px", padding: 15, height: "100%", display: "flex", flexDirection: "column" }}
          >
            <Grid
              style={{ marginBottom: 10, position: "sticky", top: 0, zIndex: 5, backgroundColor: "white" }}
              sx={{ pt: 1, pl: 1 }}
              container
              spacing={1}
              display={"flex"}
              width={"100%"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Grid item xs={12} sm={6}  >
                <Typography
                  sx={{
                    fontSize: '16px',
                    color: '#373A45',
                    fontWeight: '500',
                    textAlign: 'start',
                    mb: { xs: 2, md: 0 },
                    '@media (max-width: 600px)': {
                      fontSize: '16px',
                    },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '12px !important',
                    },
                    '@media (min-width: 1920px) and (max-width: 1940px)': {
                      fontSize: '20px !important',
                    },
                  }}
                >
                  {'All Photos'}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: { xs: 'space-between', sm: 'flex-end' },
                    gap: 1,
                    width: '100%',
                  }}
                >
                  <Box sx={{ flex: { xs: '1 1 35%', sm: '0 0 auto' }, minWidth: { xs: '35%', sm: 'auto' } }}>
                    <FormControl fullWidth>
                      <Button
                        size="medium"
                        variant="contained"
                        color="info"
                        endIcon={<img src={FilterIcon} alt="filter" style={{ width: 24, height: 24 }} />}
                        onClick={handleSortButtonClick}
                        type="button"
                        fullWidth
                      >
                        <Typography sx={{ fontWeight: 500 }}>
                          {sortLabel ? sortLabel : 'Sort by'}
                        </Typography>
                      </Button>

                      <Menu
                        anchorEl={anchorEl}
                        open={isSortMenuOpen}
                        onClose={handleSortMenuClose}
                        PaperProps={{
                          sx: {
                            borderRadius: 2,
                            minWidth: 180,
                            boxShadow: 3,
                            mt: 1,
                            backgroundColor: '#FFFFFF',
                          },
                        }}
                      >
                        <MenuItem
                          onClick={() => handleSortSelect('')}
                          selected={sortLabel === ''}
                          sx={{ fontWeight: sortLabel === '' ? 600 : 400 }}
                        >
                          Clear
                        </MenuItem>

                        {sortOptions.map((option) => (
                          <MenuItem
                            key={option}
                            onClick={() => handleSortSelect(option)}
                            selected={sortLabel === option}
                            sx={{ fontWeight: sortLabel === option ? 600 : 400 }}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Menu>
                    </FormControl>
                  </Box>
                  <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={handleAddPhotosClick}
                    >
                      Add photos +
                    </Button>
                  </Box>
                </Box>
              </Grid>
              {isMobile && (
                <Box sx={{ position: 'fixed', bottom: 16, left: 16, right: 16, zIndex: 1200 }}>
                  <Button fullWidth variant="contained" color="primary" onClick={handleAddPhotosClick}>
                    Add photos +
                  </Button>
                </Box>
              )}
            </Grid>
            <Grid
              className={`scrollbar-cusgray ${classes.cardContainer}`}
              style={{ overflowY: "auto", flex: 1, paddingBottom: isMobile ? 90 : 20 }}
            >
              <PhotoContainer cardData={displayedPhotos} />
            </Grid>
          </Grid>
        </Grid>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Grid container style={{ height: "calc(100vh - 235px)", overflow: "hidden" }}>
          <Grid
            item
            lg={12}
            xl={12}
            style={{ backgroundColor: "white",width:"100%", borderRadius: "8px", padding: 15, height: "100%", display: "flex", flexDirection: "column" }}
          >
            <Grid
              style={{ marginBottom: 10 }}
              sx={{ pt: 1, pl: 1 }}
              container
              spacing={1}
              display={"flex"}
              justifyContent={"space-between"}
            >
              <Grid item xs={12} sm={6}>
                <Typography
                  sx={{
                    fontSize: '16px',
                    color: '#373A45',
                    fontWeight: '500',
                    textAlign: 'start',
                    mb: { xs: 2, md: 0 },
                    '@media (max-width: 600px)': {
                      fontSize: '16px',
                    },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      fontSize: '12px !important',
                    },
                    '@media (min-width: 1920px) and (max-width: 1940px)': {
                      fontSize: '20px !important',
                    },
                  }}
                >
                  {'All Albums'}
                </Typography>
              </Grid>

              <Grid item className="d-flex flex-wrap gap-3 align-items-center justify-content-end" xs={12} sm={6}>
                <Box
                  sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    alignItems: 'center',
                    justifyContent: { xs: 'space-between', sm: 'flex-end' },
                    gap: 1,
                    width: '100%',
                  }}
                >
                  <Box sx={{ flex: { xs: '1 1 35%', sm: '0 0 auto' }, minWidth: { xs: '35%', sm: 'auto' } }}>
                    <FormControl fullWidth>
                      <Button
                        size="medium"
                        variant="contained"
                        color="info"
                        endIcon={<img src={FilterIcon} alt="filter" style={{ width: 24, height: 24 }} />}
                        onClick={handleSortButtonClick}
                        type="button"
                        fullWidth
                      >
                        <Typography sx={{ fontWeight: 500 }}>
                          {sortLabel ? sortLabel : 'Sort by'}
                        </Typography>
                      </Button>

                      <Menu
                        anchorEl={anchorEl}
                        open={isSortMenuOpen}
                        onClose={handleSortMenuClose}
                        PaperProps={{
                          sx: {
                            borderRadius: 2,
                            minWidth: 180,
                            boxShadow: 3,
                            mt: 1,
                            backgroundColor: '#FFFFFF',
                          },
                        }}
                      >
                        <MenuItem
                          onClick={() => handleSortSelect('')}
                          selected={sortLabel === ''}
                          sx={{ fontWeight: sortLabel === '' ? 600 : 400 }}
                        >
                          Clear
                        </MenuItem>

                        {sortOptions.map((option) => (
                          <MenuItem
                            key={option}
                            onClick={() => handleSortSelect(option)}
                            selected={sortLabel === option}
                            sx={{ fontWeight: sortLabel === option ? 600 : 400 }}
                          >
                            {option}
                          </MenuItem>
                        ))}
                      </Menu>
                    </FormControl>
                  </Box>
                  <Box sx={{ display: { xs: 'none', sm: 'block' } }}>
                    <Button
                      fullWidth
                      variant="contained"
                      color="primary"
                      onClick={handleAddAlbumClick}
                    >
                      Create Album +
                    </Button>
                  </Box>
                </Box>
              </Grid>
              {isMobile && (
                <Box sx={{ position: 'fixed', bottom: 16, left: 16, right: 16, zIndex: 1200 }}>
                  <Button fullWidth variant="contained" color="primary" onClick={handleAddAlbumClick}>
                    Create Album +
                  </Button>
                </Box>
              )}


              <CreateAlbumModal
                open={createAlbumModalOpen}
                onClose={() => setCreateAlbumModalOpen(false)}
                onSuccess={handleAlbumCreationSuccess}
              />
            </Grid>
            <Grid
              className={`scrollbar-cusgray ${classes.cardContainer}`}
              style={{ overflowY: "auto", flex: 1, paddingBottom: isMobile ? 90 : 20 }}
            >
              <AlbumContainer cardData={displayedAlbums} />
            </Grid>
          </Grid>

        </Grid>
      </CustomTabPanel>
    </Box>
  );
};
export default Photos;
